module.exports = __webpack_public_path__ + "static/media/kindBg.0baf6221.jpg";